import { render, staticRenderFns } from "./PlanetaryTrackReward.vue?vue&type=template&id=21f77f73"
import script from "./PlanetaryTrackReward.vue?vue&type=script&lang=ts"
export * from "./PlanetaryTrackReward.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports